export const SMB_BUSINESS_ROOT = '/gift-cards-for-business/'
export const SMB_BUSINESS_LOGIN = '/gift-cards-for-business/login/'
export const SMB_BUSINESS_REGISTRATION =
    '/gift-cards-for-business/registration/'
export const SMB_BUSINESS_DETAILS = '/gift-cards-for-business/details/'
export const SMB_BUSINESS_CUSTOMIZE = '/gift-cards-for-business/customize/'
export const SMB_BUSINESS_CONFIRMATION =
    '/gift-cards-for-business/confirmation/'
export const SMB_BUSINESS_CANCELLED =
    '/gift-cards-for-business/order-cancelled/'
export const SMB_BUSINESS_RESUBMISSION =
    '/gift-cards-for-business/resubmit/'
export const SMB_BUSINESS_EXPRESS = '/gift-cards-for-business/express/'
export const SMB_BUSINESS_MERCHANT_DIRECTORY =
    '/gift-cards-for-business/merchants/'
export const SMB_BUSINESS_MERCHANT = '/gift-cards-for-business/:merchant/'
export const SMB_PLACE_ORDER = '/gift-cards-for-business/place-order/'
export const CUSTOM_GREETING_CARDS = '/custom-greeting-cards/'
export const BUY_LOCAL_GIFT_CARDS = '/buy-local-gift-cards/'
export const FREE_GIFT_CARDS = '/free-gift-cards/'
export const E_GIFT_CARDS = '/e-gift-cards/'
export const BUY_BULK_GIFT_CARDS = '/bulk-gift-cards/?buyingFor=company/'
export const ABOUT = '/about/'
export const PRESS = '/press/'
export const CONTACT_US = '/contact-us/'
export const IMAGE_GUIDELINES = '/image-guidelines/'
/** List of routes excluded from SMB merchant wildcard matching for improved routing accuracy. **/
export const NON_MERCHANT_SMB_EXCLUSION_ROUTES = [
    SMB_PLACE_ORDER,
    SMB_BUSINESS_ROOT,
    SMB_BUSINESS_LOGIN,
    SMB_BUSINESS_REGISTRATION,
    SMB_BUSINESS_DETAILS,
    SMB_BUSINESS_CUSTOMIZE,
    SMB_BUSINESS_CONFIRMATION,
    SMB_BUSINESS_CANCELLED,
    SMB_BUSINESS_RESUBMISSION,
    SMB_BUSINESS_EXPRESS,
    SMB_BUSINESS_MERCHANT_DIRECTORY,
]

// Extract just the unique parts after the /gift-cards-for-business/ prefix
export const smbMerchantExclusionPattern =
    NON_MERCHANT_SMB_EXCLUSION_ROUTES.map((route) => {
        // Remove the /gift-cards-for-business/ prefix and escape remaining slashes
        return route.replace(SMB_BUSINESS_ROOT, '').replace(/\//g, '\\/').trim()
    }).join('|')

// Construct a RegExp that matches any route under "/gift-cards-for-business/"
// which does NOT match any of the excluded routes.
export const smbMerchantRegex = new RegExp(
    `^\\/gift\\-cards\\-for\\-business\\/(?!(${smbMerchantExclusionPattern})(\\/|$)).*`
)
